module.exports = __webpack_public_path__ + "img/functionality.821c0ed7.png";